var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout app-layout-backend"},[_c('nav-bar',{on:{"handle-dark":_vm.toggleDarkMode}}),_c('b-container',{class:{ 'text-dark bg-light ': !_vm.isDarkMode, 'text-light bg-dark ': _vm.isDarkMode },attrs:{"fluid":""}},[_vm._t("default"),_c('footer-bar')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }